import { Grid, GridItem, Heading } from '@chakra-ui/react';
import { FrontEndProcessingModel } from '@ssar-app/domain';

export interface FrontEndProcesssingSummaryProps {
  model?: FrontEndProcessingModel;
}

export const FrontEndProcesssingSummary = (
  props: FrontEndProcesssingSummaryProps,
) => {
  return (
    <>
      <Heading
        as={'h3'}
        textAlign={'center'}
        color={'#1d4f91'}
        marginTop={2}
        marginBottom={2}
        fontSize={'md'}
        fontFamily={'Roboto'}
        fontWeight={'normal'}
      >
        Input File
      </Heading>
      <Grid templateColumns='repeat(6, 1fr)' gap={2}>
        <GridItem textAlign={'right'}>
          <strong>Client File Name:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.model?.clientInputFileName || 'NA'}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>File Name::</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.model?.experianInputFileName || 'NA'}
        </GridItem>
        <GridItem textAlign={'right'}>
          <strong>Record Quantity:</strong>
        </GridItem>
        <GridItem colSpan={5} marginLeft={1}>
          {props.model?.inputQuantity || 'NA'}
        </GridItem>
      </Grid>
    </>
  );
};
